module.exports = __webpack_public_path__ + "static/no-results-bg-ebeb6ebf5b7dccceae50d793aafb6c4a.gif";